/** Sayfalı liste yanıtı — /panel/api/devices gibi uçların ortak zarfı. */
export interface Paged<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

/** API hata gövdesi — FastAPI {detail}, eski uçlar {error} döner. */
export interface ApiErrorBody {
  error?: string;
  detail?: string;
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: ApiErrorBody | null,
  ) {
    super(body?.error ?? body?.detail ?? `HTTP ${status}`);
    this.name = 'ApiError';
  }
}
